export default {
    calamp_info_title: "Calamp",
    esn: "ESN",
    firmwareVersion: "Versión del firmware",
    group: "Grupo",
    configGroup: "Configuración del grupo",
    mobileIdType: "Id. del tipo de móvil",
    modemSelections: "Selecciones de módem",
    ipAddress: "Dirección IP",
    mobileId: "Id. del móvil",
    imei: "IMEI",
    imsi: "IMSI",
    min: "Min",
    vehicleClass: "Clase de vehículo",
    scriptVersion: "Versión del script",
    configVersion: "Versión de configuración",
    unitStatusBit1: "Bit de estado de la unidad 1",
    unitStatusBit2: "Bit de estado de la unidad 2",
    unitStatusBit3: "Bit de estado de la unidad 3",
    unitStatusBit4: "Bit de estado de la unidad 4",
    unitStatusBit5: "Bit de estado de la unidad 5",
    unitStatusBit6: "Bit de estado de la unidad 6",
    unitStatusBit7: "Bit de estado de la unidad 7",
    unitStatusBit8: "Bit de estado de la unidad 8",
    configFailReasonId: "Id. del motivo del error de configuración",
    configStatus: "Estado de configuración",
    firmwareStatus: "Estado del firmware",
    imeiHex: "IMEI Hex",
    appId: "Id. de la App",
    customerName: "Nombre del cliente",
    empty: "Vacío",
    version: "Versión",
    configVer: "Config Ver",
    scriptVer: "Script Ver",
    iccId: "ICC Id",
    queryId: "Query Id",
    bitmap: "Bitmap",
    unitStatus1: "Estado de la unidad 1",
    gpsantennaStatusOK: "Estado de la antena GPS OK",
    gpsreceiverTestOK: "Prueba de receptor GPS OK",
    gpstrackingOK: "Rastreo GPS OK",
    modemMinTestOK: "Prueba mínima de módem OK",
    gpsexceptionReported: "Excepción GPS Reportado",
    bit8Ok: "Bit 8 Ok",
    bit6Ok: "Bit 6 Ok",
    trackingNum: "El número de rastreo",
    customerPO: "PO del cliente",
    freightCost: "Costo del flete",
    shippedDate: "Fecha de envío",
    unitPartNumber: "Número de pieza de la unidad",
    boardPartNumber: "Número de pieza de la placa",
    manufactureDate: "Fecha de fabricacion",
    versionNumber: "Número de versión",
    downloadFailure: "Error de descarga",
    downloadRetryCount: "Conteo de reintentos de descarga",
    downloadRequestTime: "Tiempo de solicitud de descarga",
    lastUpdateTime: "Hora de la última actualización",
    firstIdReportTime: "Hora del informe de la primera identificación",
    lastIdReportTime: "Hora del último informe de identificación",
    go_to_puls: "Ir a PULS",

    //new
    idReport: "Id Report",
    vinValid: "Vin Valid",
    extension: "Extension",
    otaId: "Ota Id",
    vbusIdReport: "Vbus Id Report",
    statCode: "Stat Code",
    haidReport: "Haid Report",
    diagCode: "Diag Code",
    vinInfoStatus: "Vin Info Status",
    diagString: "Diag String",
    vbusDiag: "Vbus Diag",
    Imei: "IMEI",
    typeId: "Type Id",
    customId: "Custom Id",
    statusCode: "Status Code",
    infoListString: "Info List String",
    rawFileTable: "Raw File Table",
    serviceConfigVersion: "Service Config Version",
    custList: "Cust Code",
    lastConfigUpdateTime: "Las Config Update Time",
    extentionPrefix: "Extention Prefix",
    lastConfigSyncTime: "Last Config Sync Time",
    meid2: "Meid 2",
    mcc: "MCC",
    Vin: "VIN",
    linuxFileReport: "Linux File Report",
    mnc: "MNC",
    cellRadioIdReport: "Cell Radio Id Report",
    mbnName: "Mbn Name",
    calamp_info_url: "Ir a Calamp",
    calamp_formatted: "Con formato",
    calamp_unformatted: "Formato JSON",
    message: "Mensaje",
    calamp_info: "Información",
    calamp_files: "Archivos",
    calamp_files_file_type: "Tipo de Archivo",
    calamp_files_last_update: "Última Actualización",
    calamp_files_new_version: "Nueva Versión",
    calamp_files_status: "Estado",
    calamp_files_current: "Actual",
    calamp_files_log: "Histórico",
    calamp_puls_customer_missing: "No se encontro el PulsCustomerId"
}